import api from '@calendar/api'

export interface MenuInfo {
    name: string
    id: string
    icon?: string
    select: boolean
    expand: boolean
    child?: MenuInfo[]
    path?: string
    type: string
    color?: string
    folder?: calendar.Folder | null
}

const menues: MenuInfo[] = [
    {
        name: '일정 조회',
        id: '',
        icon: 'home2',
        select: false,
        expand: false,
        child: [],
        path: 'calendar-main',
        type: 'router-link',
    },
    {
        name: '내 일정',
        id: '0',
        icon: 'box',
        select: false,
        expand: false,
        child: [],
        type: ''
    },
    {
        name: '회사 일정',
        id: '1',
        icon: 'box',
        select: false,
        expand: false,
        child: [],
        type: ''
    },
    {
        name: '부서 일정',
        id: '2',
        icon: 'box',
        select: false,
        expand: false,
        child: [],
        type: ''
    }
]

const colorArray = [
    '#ff4b09',
    '#ffc609',
    '#e0ff03',
    '#bdff09',
    '#29e1bf',
    '#0942ff',
    '#241eb4',
    '#c609ff',
    '#ff119a',
    '#c9dbdb',
]

export default menues

const getMyFolderList = function() {
    var myFolder = menues.find(x => x.name == '내 일정')?.child
    api.ews_folder.getMyFolderItems('').then((folders) => {
        folders.map((folder: calendar.Folder, index) => {
            console.log(index)
            var folderItem: MenuInfo = {
                name: '',
                id: '',
                select: false,
                expand: false,
                type: '',
                color: '',
                folder: null
            }
            folderItem.name = folder.displayName
            folderItem.id = folder.id
            folderItem.color = !folder.colorCode || folder.colorCode == 'none' ? colorArray[index] : folder.colorCode
            folderItem.folder = folder

            myFolder?.push(folderItem)
        })
    })
}

const getCompanyList = function() {
    var myFolder = menues.find(x => x.name == '회사 일정')?.child
    api.db_main.getCompanyFolderList('').then((folders) => {
        console.log('folders', folders)
        folders.map((folder: calendar.Folder, index) => {
            var folderItem: MenuInfo = {
                name: '',
                id: '',
                select: false,
                expand: false,
                type: '',
                color: '',
                folder: null
            }
            folderItem.name = folder.displayName
            folderItem.id = folder.id
            folderItem.folder = folder

            myFolder?.push(folderItem)
        })
    })
}

const getDeptFolderList = function() {
    var myFolder = menues.find(x => x.name == '부서 일정')?.child
    api.db_main.getDeptFolderList('').then((folders) => {
        folders.map((folder: calendar.Folder) => {
            var folderItem: MenuInfo = {
                name: '',
                id: '',
                select: false,
                expand: false,
                type: '',
                color: '',
                folder: null
            }
            folderItem.name = folder.displayName
            folderItem.id = folder.id
            folderItem.folder = folder

            myFolder?.push(folderItem)
        })
    })
}

getMyFolderList()
getCompanyList()
getDeptFolderList()